import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./casting-urssaf-payment.component.yml'))

export default class CastingUrssafPaymentComponent extends React.Component<StoreProps, never> {
  render () {
    const { store, data: { market, urssafPayment, offeredService } } = this.props
    if (!market['urssaf_payment_ask_in_casting?'] || !offeredService?.['urssaf_payment_eligible?']) return null

    return <div className="inputCheckbox">
      <input type="checkbox" id="casting-urssaf-payment" checked={ urssafPayment } onChange={ evt => store.set({ urssafPayment: evt.target.checked }) } />
      <label htmlFor="casting-urssaf-payment">{ i18nScoped.t('opt_for_urssaf_payment') }</label>
      <p className="castingStep-desc paragraph--desc u-mtn">{ i18nScoped.t('additional_info_asked_later') }</p>
    </div>
  }
}
